import {
  Typography,
  Dialog as MuiDialog,
  DialogContent,
  DialogTitle,
  Button,
  Box,
  Link as MuiLink,
  styled,
  css,
} from '@mui/material';
import { Link } from 'react-router-dom';

import VielmobilLogo from '@/assets/logos/vielmobil.svg?react';
import { useUserStore } from '@/stores/useUserStore';

const StyledDialog = styled(MuiDialog)(
  ({ theme }) => css`
    & .MuiDialog-paper {
      border-radius: ${theme.spacing(3)};
      background: ${theme.palette.primary.main};
    }

    text-align: center;
  `,
);

const StyledButton = styled(Button)(
  ({ theme }) => css`
    color: ${theme.palette.primary.main};
    text-decoration: none;
    font-weight: bold;
    text-transform: none;
    background: white;
    border-radius: 24px;

    &.MuiButtonBase-root:hover {
      background-color: ${theme.palette.common.white};
      opacity: 0.5;
    }
  `,
);

const StyledLink = styled(MuiLink)(
  ({ theme }) => css`
    color: ${theme.palette.common.white};
    text-decoration: none;
    font-weight: bold;
  `,
) as typeof MuiLink;

export function Dialog() {
  const dialogVisible = useUserStore((state) => state.dialogVisible);

  const { setDialogVisible } = useUserStore((state) => state.actions);

  const handleClose = () => {
    setDialogVisible(false);
  };

  return (
    <StyledDialog maxWidth="sm" onClose={handleClose} open={dialogVisible}>
      <DialogTitle component="div">
        <Box
          sx={{
            mb: 2,
          }}
        >
          <VielmobilLogo />
        </Box>
        <Typography
          variant="h1"
          sx={{
            mb: 2,
            fontSize: '1.2rem',
            fontWeight: 'bold',
          }}
        >
          Herzlich Willkommen auf dem Webportal für Alltagsmobilität in Frankfurt RheinMain!
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography
          sx={{
            mb: 2,
          }}
        >
          Vielmobil ist ein intermodales Auskunftssystem für die Region Frankfurt RheinMain. Die Berücksichtigung von
          stadt- und umweltsensitiven Verkehrslenkungsmaßnahmen befindet sich derzeit im Testbetrieb.
          <br />
          <StyledLink component={Link} to="/ueber-das-projekt">
            Mehr erfahren
          </StyledLink>
        </Typography>

        <StyledButton onClick={() => handleClose()} size="large">
          Weiter
        </StyledButton>
      </DialogContent>
    </StyledDialog>
  );
}
